import { style, styleVariants } from "@vanilla-extract/css";

import { vars } from "~/styles/tokens.css";

// Inline banner. Larger than a badge, smaller than a card. Paints a
// tinted status surface with matching border + on-surface text. The
// icon slot (left) is optional — callers pass any ReactNode.
const base = style({
  display: "flex",
  alignItems: "flex-start",
  gap: vars.space.sm,

  fontFamily: vars.font.body,
  fontSize: vars.fontSize.sm,
  lineHeight: vars.lineHeight.normal,

  paddingBlock: vars.space.sm,
  paddingInline: vars.space.md,
  borderRadius: vars.radius.md,
  borderWidth: "1px",
  borderStyle: "solid",
});

export const alert = styleVariants({
  info: [
    base,
    {
      backgroundColor: vars.color.infoSurface,
      borderColor: vars.color.infoSurfaceBorder,
      color: vars.color.infoOnSurface,
    },
  ],
  success: [
    base,
    {
      backgroundColor: vars.color.successSurface,
      borderColor: vars.color.successSurfaceBorder,
      color: vars.color.successOnSurface,
    },
  ],
  warning: [
    base,
    {
      backgroundColor: vars.color.warningSurface,
      borderColor: vars.color.warningSurfaceBorder,
      color: vars.color.warningOnSurface,
    },
  ],
  danger: [
    base,
    {
      backgroundColor: vars.color.dangerSurface,
      borderColor: vars.color.dangerSurfaceBorder,
      color: vars.color.dangerOnSurface,
    },
  ],
});

export const alertIcon = style({
  flexShrink: 0,
  lineHeight: vars.lineHeight.tight,
  // Nudge the icon up slightly so it aligns with the first line of
  // text rather than centering on a possibly-multi-line body.
  marginTop: "1px",
});

export const alertBody = style({
  flex: 1,
  minWidth: 0,
});
